import React, { useMemo, useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { useTranslate } from "hooks";
import { Icon } from "components";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import OrderCodePart from "./OrderCodePart";
import { ProductConfiguratorHeaderSaveUndoButtons } from "./ProductConfiguratorHeaderSaveUndoButtons";

export const OrderCode = ({
  isModalView,
  isWizardView,
  handleOpenConfModal,
  activePart,
  activatePartItem,
  isConfigurationModalOpened,
}) => {
  const translate = useTranslate();
  const productData = useProductConfiguratorStore.use.productData();
  const isOrderCodeLoading = useProductConfiguratorStore.use.isLoading();

  const allOptionsTooltipRef = useRef(null);
  const presentationParts = useMemo(
    () =>
      productData?.product?.orderCode?.parts?.filter(
        (part) =>
          // 0 - RelevantChangeable; 1 - RelevantNotChangeable
          // https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_wiki/wikis/TROX-System-Configurator.wiki/1132/Product-states
          part.state === 0 ||
          part.state === 1 ||
          (part.state === 3 && part.presentation),
      ) || [],
    [productData],
  );

  return (
    <div className="d-flex flex-wrap align-items-center gap-1">
      {!isModalView && (
        <>
          <button
            className="d-flex justify-content-center align-items-center p-0 bg-transparent border-0"
            ref={allOptionsTooltipRef}
          >
            <Icon
              prefix="trox"
              iconName="squares-regular"
              id="product-configurator-grid-2-icon"
              className="icon-20 text-gray-700 cursor-pointer"
              onClick={handleOpenConfModal}
            />
          </button>
          <UncontrolledTooltip
            placement="top"
            target={allOptionsTooltipRef || null}
          >
            {translate("PRODUCT_CONFIGURATOR_SHOW_ALL_OPTIONS_BUTTON_TOOLTIP")}
          </UncontrolledTooltip>
        </>
      )}
      {presentationParts.map((part) => (
        <OrderCodePart
          key={part.key}
          part={part}
          activePart={activePart}
          activatePartItem={activatePartItem}
          isConfigurationModalOpened={isConfigurationModalOpened}
          isFetchingOrderCodeProcess={isOrderCodeLoading}
        />
      ))}
      <ProductConfiguratorHeaderSaveUndoButtons isWizardView={isWizardView} />
    </div>
  );
};
